export const GET_COURSE_REQUEST = 'COURSE_AGENDA_CALENDAR_GET_COURSE_REQUEST';
export const GET_COURSE_SUCCESS = 'COURSE_AGENDA_CALENDAR_GET_COURSE_SUCCESS';

export const GET_COURSE_AGENDA_REQUEST = 'COURSE_AGENDA_CALENDAR_GET_COURSE_AGENDA_REQUEST';
export const GET_COURSE_AGENDA_SUCCESS = 'COURSE_AGENDA_CALENDAR_GET_COURSE_AGENDA_SUCCESS';

export const GET_COURSE_RELEASE_CONFIGS_REQUEST = 'COURSE_AGENDA_CALENDAR_GET_COURSE_RELEASE_CONFIGS_REQUEST';
export const GET_COURSE_RELEASE_CONFIGS_SUCCESS = 'COURSE_AGENDA_CALENDAR_GET_COURSE_RELEASE_CONFIGS_SUCCESS';

export const GET_COURSE_RESERVATIONS_REQUEST = 'COURSE_AGENDA_CALENDAR_GET_COURSE_RESERVATIONS_REQUEST';
export const GET_COURSE_RESERVATIONS_SUCCESS = 'COURSE_AGENDA_CALENDAR_GET_COURSE_RESERVATIONS_SUCCESS';

export const GET_COURSE_RESERVATION_REQUESTS_REQUEST = 'COURSE_AGENDA_CALENDAR_GET_RESERVATION_REQUESTS_REQUEST';
export const GET_COURSE_RESERVATION_REQUESTS_SUCCESS = 'COURSE_AGENDA_CALENDAR_GET_RESERVATION_REQUESTS_SUCCESS';

export const DISPOSE = 'COURSE_AGENDA_CALENDAR_DISPOSE_STORE';
